export default (store) => {
    const userStore = store.ng.injector.get('Users'),
        pusher = userStore.dispatch('getPusher'),
        pusherEventCallBack = (data) => {
            store.dispatch('getData');
        };

    pusher.bind('job-log-state-change', pusherEventCallBack, this);

    store.state.activePusherListeners.push({
        event: 'job-log-state-change',
        callback: pusherEventCallBack
    });
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/register-pusher-listeners.js